var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "rbacViewServicesModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header modal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.cancelPermissions },
              },
              [_vm._v("×")]
            ),
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.selectedRoleName)),
            ]),
            _c("hr"),
          ]),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._l(_vm.servicesList, function (services, index) {
                return [
                  services.access
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "module-text col-xs-12 col-sm-12",
                        },
                        [
                          _c("div", { staticClass: "label_container" }, [
                            _c(
                              "div",
                              {
                                staticClass: "ml-18 cursor-pointer flex_grow_1",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target":
                                    "#" + index + "_serviceCollapse",
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(services.name))]),
                                _c("span", {
                                  staticClass:
                                    "collapse_arrow fa fa-angle-down",
                                }),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "collapse mr-lt-30",
                              attrs: { id: index + "_serviceCollapse" },
                            },
                            [
                              _vm._l(
                                services.modules,
                                function (module, modIndex) {
                                  return [
                                    module.access
                                      ? _c(
                                          "div",
                                          {
                                            key: modIndex,
                                            staticClass: "desc_text mr-rt-30",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ml-18 cursor-pointer flex_grow_1",
                                                attrs: {
                                                  "data-toggle": "collapse",
                                                  "data-target":
                                                    "#" +
                                                    index +
                                                    "_" +
                                                    modIndex +
                                                    "_modCollapse",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(module.name)),
                                                ]),
                                                _c("span", {
                                                  staticClass:
                                                    "collapse_arrow fa fa-angle-down",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "collapse mr-lt-30",
                                                attrs: {
                                                  id:
                                                    index +
                                                    "_" +
                                                    modIndex +
                                                    "_modCollapse",
                                                },
                                              },
                                              [
                                                _vm._l(
                                                  module.operations,
                                                  function (
                                                    operation,
                                                    opIndex
                                                  ) {
                                                    return [
                                                      operation.access
                                                        ? _c(
                                                            "div",
                                                            {
                                                              key: opIndex,
                                                              staticClass:
                                                                "desc_text mr-rt-30",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cust_label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      operation.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c("div", { staticClass: "modal-footer modal-bgcolor" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-3 col-md-offset-9 col-sm-offset-8 col-sm-4 col-xs-6 col-xs-offset-6 xs-pd-lt-0",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-blue-button",
                        attrs: { type: "button" },
                        on: { click: _vm.cancelPermissions },
                      },
                      [_vm._v(" OK ")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }